import { Backbone, _ } from "js/vendor";
let isConnected = _.extend({ connected: window.navigator.onLine }, Backbone.Events);

window.addEventListener("offline", () => {
    triggerIsOnlineChange(false);
});

window.addEventListener("online", () => {
    triggerIsOnlineChange(true);
});

function triggerIsOnlineChange(connected) {
    isConnected.connected = connected;
    isConnected.trigger("change");
}

export default isConnected;
